import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ConfirmationStep = ({ onContinueShopping }) => (
  <div className="p-10 sm:p-16 text-center">
    <div className="w-16 h-16 rounded-full bg-accent-soft flex items-center justify-center mx-auto mb-6">
      <CheckCircle2 className="w-8 h-8 text-accent" />
    </div>
    <h3 className="font-display text-3xl text-ink mb-3">Order confirmed</h3>
    <p className="text-ink-soft max-w-sm mx-auto mb-8">
      Thank you — we're preparing your order now. You'll get an SMS and email as it moves through packing and delivery.
    </p>
    <button
      onClick={onContinueShopping}
      className="bg-ink text-paper dpc-label px-8 py-3.5 rounded-full hover:bg-accent transition-colors"
    >
      Continue shopping
    </button>
  </div>
);

export default ConfirmationStep;
